/* eslint-disable no-barrel-files/no-barrel-files */

import {
  ChartSlashCommandProvider,
  useChartSlashCommandContext,
} from 'features/richText/contexts/ChartSlashCommandContext'
import { RolodexEntryType } from 'types'

import { ChartSlashCommandCard } from './ChartSlashCommandCard'
import {
  DefaultSlashCommandCard,
  SlashCommandCardProps,
} from './DefaultSlashCommandCard'
import { InspectionSlashCommandCard } from './InspectionSlashCommandCard'
import { SystemSlashCommandCard } from './SystemSlashCommandCard'
import { UnitSlashCommandCard } from './UnitSlashCommandCard'

export type SlashCommandCardComponent = React.FC<SlashCommandCardProps>

export const SLASH_COMMAND_REGISTRY: Partial<
  Record<RolodexEntryType, SlashCommandCardComponent>
> = {
  [RolodexEntryType.UNIT]: UnitSlashCommandCard,
  [RolodexEntryType.SYSTEM]: SystemSlashCommandCard,
  [RolodexEntryType.INSPECTION]: InspectionSlashCommandCard,
  [RolodexEntryType.CHART]: ChartSlashCommandCard,
}

export const getSlashCommandComponent = (
  type: RolodexEntryType
): SlashCommandCardComponent => {
  return SLASH_COMMAND_REGISTRY[type] || DefaultSlashCommandCard
}

export {
  ChartSlashCommandCard,
  ChartSlashCommandProvider,
  DefaultSlashCommandCard,
  InspectionSlashCommandCard,
  SystemSlashCommandCard,
  UnitSlashCommandCard,
  useChartSlashCommandContext,
}
export type { SlashCommandCardProps }
